import React from 'react';
import FaPrint from 'react-icons/lib/fa/print';
import { COPY_STRINGS } from 'Constants/translatedCopy';

export default function PrintButton(props) {
  return (
    <button className='dyslexiaPrintButton' onClick={props.onClick}>
      <FaPrint size="18" className='dyslexiaPrintButtonIcon' />
      {COPY_STRINGS.print_letters}
    </button>
  );
}